var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMessageReceived = function SvgMessageReceived(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86675 4.86865H11.4547M4.86675 8.16016H9.80769M7.32969 13.2726L4.86745 14.75V12.2794H3.22047C2.56526 12.2794 1.93689 12.0191 1.47358 11.5558C1.01028 11.0925 0.75 10.4641 0.75 9.80882V3.22059C0.75 2.56535 1.01028 1.93694 1.47358 1.47362C1.93689 1.01029 2.56526 0.75 3.22047 0.75H13.1024C13.7576 0.75 14.3859 1.01029 14.8492 1.47362C15.3125 1.93694 15.5728 2.56535 15.5728 3.22059V8.16176M10.6326 13.1021L12.2796 14.7492L15.5735 11.4551",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessageReceived, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/messageReceived.96a37175.svg";
export { ForwardRef as ReactComponent };